import { base_path } from "../environmentSelector.js";

export const all_routes = {
  signin: base_path + "signin",
  portal: base_path + "portal",
  pos: base_path + "pos",
  backOfHouse: base_path + "back-of-house",
  default: base_path + "portal",
};

export default all_routes;
